import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink } from "react-router-dom";

//Icons

import * as FaIcons from 'react-icons/fa';
import * as RiIcons from 'react-icons/ri';
import Typography from '@mui/material/Typography';


const LoginBlock = () => {



    return (
        <div className="App-header">
                
                    <div style={{ width: '80%', justifyContent: 'space-evenly', flexDirection: 'column', alignItems: 'center', height: '500px', display: 'flex' }}>
                       
                        
                        {/* Logo and Heading */}

                        <div style={{ width: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', display: 'flex', color: '#10406B' }}>
                        <Typography variant="h5" component="h1" sx={{
                            color:'#10406B',
                            fontFamily:"'Tajawal', sans-serif",
                            fontStyle:'bold'
                        }} >
                            خدمات منصة الضرائب الطبية 
                            </Typography>
                            <Typography paragraph={true} component="p" sx={{
                            color:'#10406B',
                            fontFamily:"'Tajawal', sans-serif",
                            fontStyle:'normal',
                            textAlign: 'center'
                        }} >
                            يرجى اختيار الفئة المناسبة لهدفك ادناه
                        </Typography>
                            
                        </div>

                        {/* login sections */}
                        <div style={{ width: '100%', justifyContent: 'space-between', flexDirection: 'row', display: 'flex' }}>
                            
                            
                        <NavLink
                                className="SignIn-Card"
                                to="/mof-login"
                            >
                                <RiIcons.RiBankFill size={110} />
                                <Typography variant="h5" component="h1" sx={{
                                    color:'#10406B',
                                    fontFamily:"'Tajawal', sans-serif",
                                    textAlign:'center',
                                    fontStyle:'bold'
                                }} >
                                    بوابة وزارة المالية
                                </Typography>
                                    
                            </NavLink>
                            <NavLink
                                className="SignIn-Card"
                                to="/moh-login"
                            >
                                <FaIcons.FaUsers size={100} />
                                <Typography variant="h5" component="h1" sx={{
                                    color:'#10406B',
                                    fontFamily:"'Tajawal', sans-serif",
                                    textAlign:'center',
                                    fontStyle:'bold'
                                }} >
                                    بوابة وزارة الصحة
                                </Typography>
                                    
                            </NavLink>
                            
                            <NavLink
                                className="SignIn-Card"
                                to="/doctor-login"
                            >
                                <FaIcons.FaUserMd size={100} />
                                <div className="SignIn-button">
                                <Typography variant="h5" component="h1" sx={{
                                    color:'#10406B',
                                    fontFamily:"'Tajawal', sans-serif",
                                    textAlign:'center',
                                    fontStyle:'bold'
                                }} >
                                    بوابة الطبيب
                                </Typography>
                                </div>
                            </NavLink>
                        </div>

                        
                    </div>
                </div>
            
    )
}


export default LoginBlock;